type Orderable = {
  id: string
  team?: { id: string } | null
}

type Viewer = {
  id: string
  team?: { id: string } | null
}

/**
 * Your side first, and you first within it.
 *
 * The flight arrives in whatever order the ids fall, which put the scorer's
 * own card third of four as often as first. A split round makes that worse
 * than untidy: the entries change kind at every block boundary — teams own
 * the one-ball block, players own the rest — so an unsorted flight reshuffles
 * the cards under the scorer's thumb twice a round, at exactly the two holes
 * where the screen already changes shape.
 *
 * Your SIDE rather than just you, because the sides stay put across the
 * joints even though the entries don't: your team's card in the one-ball
 * block sits where you and your partner sit in the other two.
 *
 * A stable sort, so everything below your side keeps the order it came in —
 * flights are small and the opponents' order is the server's business.
 */
export const orderFlightForViewer = <T extends Orderable>(
  flight: readonly T[],
  viewer: Viewer
): T[] => {
  // A one-ball block's entry IS the team, so "you" is your team's id there.
  const rank = (entry: T): number => {
    if (entry.id === viewer.id || entry.id === viewer.team?.id) return 0
    if (viewer.team && entry.team?.id === viewer.team.id) return 1
    return 2
  }
  return [...flight].sort((a, b) => rank(a) - rank(b))
}
